













import { defineComponent, ref, onMounted } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const server = sl.get('serverProxy');
    const imageLink = ref<string | null>(null);

    onMounted(async () => {
      imageLink.value = await server.getResourceObject('explanation');
    });

    return {
      imageLink,
    };
  },
});
